import { render, staticRenderFns } from "./dialog-title-header.vue?vue&type=template&id=1b340e8c&scoped=true"
import script from "./dialog-title-header.vue?vue&type=script&lang=js"
export * from "./dialog-title-header.vue?vue&type=script&lang=js"
import style0 from "./dialog-title-header.vue?vue&type=style&index=0&id=1b340e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b340e8c",
  null
  
)

export default component.exports